import {getEnvironment} from '../../../../_gori/helpers/EnvironmentHelpers'

/**
 * Builds the full document title including environment suffix for non-prod.
 */
export const buildDocumentTitle = (pageTitle: string): string => {
  const env = getEnvironment()
  return env ? `${pageTitle} - ${env}` : pageTitle
}

/**
 * Returns true if the app is running in a non-production environment (Stage, Dev, Local).
 */
export const isNonProduction = (): boolean => {
  return getEnvironment() !== ''
}
